import React from 'react';
import { defaultColors } from '../../../constants/settings.constants';

interface EnhancedColorPickerProps {
  value?: string;
  onChange: (color: string) => void;
}

export const EnhancedColorPicker: React.FC<EnhancedColorPickerProps> = ({
  value,
  onChange,
}) => {
  const colorInputRef = React.useRef<HTMLInputElement>(null);

  return (
    <div>
      <div className="flex flex-wrap gap-3 mb-5">
        {defaultColors.map((color) => (
          <button
            key={color}
            type="button"
            onClick={() => onChange(color)}
            className={`w-9 h-9 rounded-full transition-transform hover:scale-110 ${value === color ? 'ring-2 ring-primary ring-offset-2' : ''}`}
            style={{
              backgroundColor: color,
              border: '1.5px solid #FFFFFF',
              boxShadow: '0px 2px 10px 0px #0000001F',
            }}
            title={color}
          />
        ))}
      </div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-text">Select custom color</p>
        <button
          type="button"
          onClick={() => colorInputRef.current?.click()}
          className="flex items-center gap-2 border border-slate-medium rounded-lg py-2 px-3 hover:bg-gray-50 transition-colors cursor-pointer relative"
        >
          <div
            className="w-5 h-5 rounded-full"
            style={{
              backgroundColor: value || '#000000',
              border: '1.5px solid #FFFFFF',
              boxShadow: '0px 2px 10px 0px #0000001F',
            }}
          />
          <span className="text-sm text-text">{value?.toUpperCase() || '#000000'}</span>
          <input
            ref={colorInputRef}
            type="color"
            value={value || '#000000'}
            onChange={(e) => onChange(e.target.value)}
            className="absolute opacity-0 pointer-events-none"
          />
        </button>
      </div>
    </div>
  );
};
